import { defineStore } from 'pinia';

let animationFrameId: number | null = null;

export const useProgressStore = defineStore('progress', {
    state: () => ({
        isLoading: false,
        progress: 0,
    }),
    actions: {
        /**
         * Start the progress indicator
         * Animates from 0 to ~90% with a decelerating speed
         */
        start() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.progress = 0;

            // Animate progress with decreasing speed
            const animate = () => {
                if (this.progress < 90) {
                    // Slow down as we approach 90%
                    const increment = (90 - this.progress) * 0.1;
                    this.progress += Math.max(increment, 0.5);
                    animationFrameId = requestAnimationFrame(animate);
                }
            };

            animate();
        },

        /**
         * Complete the progress indicator
         * Animates to 100% and then hides after a brief delay
         */
        finish() {
            if (!this.isLoading) {
                return;
            }

            // Cancel any ongoing animation
            if (animationFrameId !== null) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }

            // Jump to 100%
            this.progress = 100;

            // Hide after a brief delay
            setTimeout(() => {
                this.isLoading = false;
                this.progress = 0;
            }, 400);
        },

        /**
         * Set a specific progress value (0-100)
         */
        setProgress(value: number) {
            this.progress = Math.min(Math.max(value, 0), 100);
        },

        /**
         * Reset the progress indicator
         */
        reset() {
            if (animationFrameId !== null) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }
            this.isLoading = false;
            this.progress = 0;
        },
    },
});
